const DB_NAME = "iotripsDriverGps";
const STORE_NAME = "locationPings";
const DB_VERSION = 1;

let dbPromise;

function db() {
  if (!("indexedDB" in window)) return Promise.reject(new Error("IndexedDB unavailable"));
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        const store = database.createObjectStore(STORE_NAME, { keyPath: "clientPingId" });
        store.createIndex("scopeKey", "scopeKey", { unique: false });
      }
    };
  });
  return dbPromise;
}

async function store(mode = "readonly") {
  const database = await db();
  return database.transaction(STORE_NAME, mode).objectStore(STORE_NAME);
}

function requestPromise(request) {
  return new Promise((resolve, reject) => {
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
}

export async function queueLocationPing(scopeKey, ping) {
  const objectStore = await store("readwrite");
  await requestPromise(objectStore.put({ ...ping, scopeKey }));
}

export async function queuedLocationPings(scopeKey) {
  const objectStore = await store();
  const index = objectStore.index("scopeKey");
  const rows = await requestPromise(index.getAll(scopeKey));
  return rows.sort((left, right) => String(left.clientCapturedAt).localeCompare(String(right.clientCapturedAt)));
}

export async function removeLocationPings(clientPingIds) {
  if (!clientPingIds?.length) return;
  const objectStore = await store("readwrite");
  await Promise.all(clientPingIds.map((id) => requestPromise(objectStore.delete(id))));
}

export async function queuedLocationCount(scopeKey) {
  const objectStore = await store();
  const index = objectStore.index("scopeKey");
  return requestPromise(index.count(scopeKey));
}
